/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 */

import type { DetailPageContextType } from '@zcode-ui/web-zumper-pages'
import { useMemo } from 'react'

import { mixpanelEvent } from '../../../modules/mixpanel/thunks/mixpanelEvent'
import { mixpanelMedia } from '../../../modules/mixpanel/thunks/mixpanelMedia'
import { useDispatch } from '../../../modules/useDispatch'

export const useMixpanelThunks = () => {
  const dispatch = useDispatch()
  return useMemo(
    () => ({
      mixpanelEvent: (...args: Parameters<typeof mixpanelEvent>) =>
        dispatch(mixpanelEvent(...args)),
      mixpanelMedia: (
        ...args: Parameters<DetailPageContextType['MixpanelThunks']['mixpanelMedia']>
      ) => dispatch(mixpanelMedia(...args)),
    }),
    [dispatch]
  )
}
